import { render } from "./AlertDriver.vue?vue&type=template&id=5bc12a90&scoped=true"
import script from "./AlertDriver.vue?vue&type=script&lang=js"
export * from "./AlertDriver.vue?vue&type=script&lang=js"

import "./AlertDriver.vue?vue&type=style&index=0&id=5bc12a90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc12a90"]])

export default __exports__